import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';
import { SnackBarService } from '../shared-services/services/snack-bar.service';

@Injectable({
    providedIn: 'root'
})
export class OtpGuard  {
    constructor(
        private router: Router,
        private authService: AuthService,
        private snackBarService: SnackBarService
    ) { }

    canActivate(next?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.authService.isChangePasswordRequired()) {
            this.snackBarService.openErrorSnackbar('You must reset your password before continuing.');
            this.router.navigate(['profile'], {
                queryParams: { tab: 'password' }
            });

            return false;
        }

        return true;
    }
}
